module.exports = __webpack_public_path__ + "static/media/email.73d28cf0.svg";